// import { useState, useEffect } from "react";
// import {
//   BirthdayMessageDetails,
//   GeneralMessageDetails,
// } from "../components/messages";
// import { MessagesContainer } from "../components/messages";
// import { FormRowSelect } from "../components";
// import Wrapper from "../assets/wrappers/DashboardFormPage";
// import { useOutletContext, redirect, useParams } from "react-router-dom";
// import { Form, useNavigation, useLoaderData } from "react-router-dom";
// import { toast } from "react-toastify";
// import { customFetch } from "../utils/custom-fetch.js";

// export const loader = async ({ params }) => {
//   try {
    
//     const buildingResponse = await customFetch.get(`/buildings/${params.id}`);
//     const messagesResponse = await customFetch(
//       `/messages?buildingId=${params.id}`
//     );

//     let messageToEdit = null;
//     if (params.messageId) {
//       const messageResponse = await customFetch.get(
//         `/messages/${params.messageId}`
//       );
//       messageToEdit = messageResponse.data;
//     }

//     window.scrollTo(0, 0);

//     return {
//       building: buildingResponse.data,
//       messages: messagesResponse.data,
//       messageToEdit,
//     };
//   } catch (error) {
//     toast.error(error.response?.data?.msg);
//     return redirect("/dashboard/all-buildings");
//   }
// };

// export const action = async ({ request, params }) => {
//   const formData = await extractFormData(request);
//   const fullData = constructMessageDetails(formData, params.id);
//   try {
//     const endpoint = params.messageId ? `/messages/${params.messageId}` : "/messages";
//     const method = params.messageId ? 'put' : 'post';
//     await customFetch[method](endpoint, fullData);
//     toast.success(`ההודעה ${params.messageId ? 'עודכנה' : 'נוצרה'} בהצלחה`);
//     return redirect("/dashboard/all-messages");
//   } catch (error) {
//     toast.error(error?.response?.data?.msg || "שגיאה בשמירת ההודעה");
//     return error;
//   }
// };

// async function extractFormData(request) {
//   const formData = await request.formData();
//   const data = Object.fromEntries(formData);
//   return data;
// }

// function constructMessageDetails(data, buildingId) {
//   let messageDetails = {};
//   switch (data.messageType) {
//     case "יום הולדת":
//       messageDetails = {
//         celebratorName: data["birthdayDetails.celebratorName"],
//         greeting: data["birthdayDetails.greeting"],
//         birthdayDate: data["birthdayDetails.birthdayDate"],
//       };
//       break;
//     case "כללית":
//       messageDetails = {
//         messageOption: data["generalMessageDetails.messageOption"],
//         startingDate: data["generalMessageDetails.startingDate"] || "",
//         expirationDate: data["generalMessageDetails.expirationDate"] || "",
//         text: data["generalMessageDetails.text"] || "",
//       };
//       break;
//     default:
//       throw new Error("Unhandled message type");
//   }

//   return {
//     messageType: data.messageType,
//     messageDetails,
//     target: {
//       type: "building",
//       buildings: [buildingId], // Use the passed buildingId directly
//     },
//   };
// }

// function cleanData(data) {
//   delete data["generalMessageDetails.messageOption"];
//   delete data["generalMessageDetails.startingDate"];
//   delete data["generalMessageDetails.expirationDate"];
//   delete data["generalMessageDetails.text"];
// }

// const AddMessage = () => {
//   const { id, messageId } = useParams();

//   if (!id) {
//     navigate("/dashboard/all-messages");
//   }

//   const { building, messages, messageToEdit } = useLoaderData();
  
//   const { user } = useOutletContext();
//   const navigate = useNavigation();
//   const isSubmitting = navigate.state === "submitting";

//   // הגדרת המצב הראשוני
//   const initialState = messageToEdit
//     ? {
//         author: messageToEdit.author,
//         messageType: messageToEdit.messageType,
//         buildingId: messageToEdit.buildingId,
//         generalMessageDetails: messageToEdit.messageDetails || {},
//         birthdayDetails: messageToEdit.messageDetails || {},
//       }
//     : {
//         author: user._id,
//         messageType: "כללית",
//         buildingId: id,
//         generalMessageDetails: {
//           messageOption: "קבועה",
//           startingDate: "",
//           expirationDate: "",
//           text: "",
//         },
//         birthdayDetails: {
//           celebratorName: "",
//           greeting: "",
//           age: "",
//           birthdayDate: "",
//         },
//       };

//   const [formData, setFormData] = useState(initialState);

//   useEffect(() => {
//     if (messageToEdit) {
//       setFormData({
//         author: messageToEdit.author,
//         messageType: messageToEdit.messageType,
//         buildingId: messageToEdit.buildingId,
//         generalMessageDetails:
//           messageToEdit.messageType === "כללית"
//             ? messageToEdit.messageDetails
//             : {},
//         birthdayDetails:
//           messageToEdit.messageType === "יום הולדת"
//             ? messageToEdit.messageDetails
//             : {},
//       });
//     }
//   }, [messageToEdit]);

//   const handleMessageTypeChange = (e) => {
//     const { value } = e.target;

//     setFormData({
//       ...initialState,
//       messageType: value,
//     });
//   };

//   const handleInputChange = (e) => {
//     const { name, value } = e.target;
//     const keys = name.split(".");

//     if (keys.length > 1) {
//       // Handle nested objects
//       setFormData((prevFormData) => ({
//         ...prevFormData,
//         [keys[0]]: {
//           ...prevFormData[keys[0]],
//           [keys[1]]: value,
//         },
//       }));
//     } else {
//       // Handle non-nested properties
//       setFormData((prevFormData) => ({
//         ...prevFormData,
//         [name]: value,
//       }));
//     }
//   };

//   const validateForm = (formData) => {
//     const { messageType, ...messageDetails } = formData;

//     const birthday = messageDetails.birthdayDetails;
//     const general = messageDetails.generalMessageDetails;

//     // Check if required fields for the selected message type are filled
//     if (messageType === "יום הולדת") {
//       const { celebratorName, greeting, birthdayDate } = birthday;

//       return Object.values({
//         celebratorName,
//         greeting,
//         birthdayDate,
//       }).every((field) => field !== "");
//     } else if (messageType === "כללית") {
//       if (messageDetails.text !== "") {
//         const { messageOption, startingDate, expirationDate } = general;
//         if (messageOption === "קבועה") {
//           return true;
//         } else if (
//           messageOption === "בין תאריכים" &&
//           expirationDate &&
//           startingDate &&
//           startingDate < expirationDate
//         ) {
//           return true;
//         } else {
//           return false;
//         }
//       }
//       return false;
//     } else {
//       console.warn("Unhandled message type:", messageType);
//       return false;
//     }
//   };

//   return (
//     <>
//       <Wrapper className="full-page">
//         <Form method="post" className="form">
//           <h4 className="form-title">
//             {messageToEdit ? "עריכת הודעה" : "הוספת הודעה"}{" "}
//             {building.building.city}, {building.building.street}{" "}
//             {building.building.houseNumber}
//           </h4>
//           <div className="form-center">
//             <FormRowSelect
//               labelText="סוג ההודעה"
//               type="text"
//               name="messageType"
//               list={["כללית", "יום הולדת"]}
//               handleChange={handleMessageTypeChange}
//               // defaultValue={formData.messageType}
//               value={formData.messageType}
//               isRequired={true}
//             />

//             {formData.messageType === "יום הולדת" && (
//               <BirthdayMessageDetails
//                 formData={formData.birthdayDetails}
//                 handleInputChange={handleInputChange}
//               />
//             )}

//             {formData.messageType === "כללית" && (
//               <>
//                 <GeneralMessageDetails
//                   formData={formData}
//                   handleInputChange={handleInputChange}
//                 />
//               </>
//             )}

//             <div className="btn-container">
//               <button
//                 type="submit"
//                 className="btn btn-block form-btn"
//                 disabled={isSubmitting || !validateForm(formData)}
//               >
//                 {isSubmitting ? "שומר..." : messageToEdit ? "עדכן" : "שמירה"}
//               </button>
//               <button
//                 className="btn btn-block clear-btn"
//                 onClick={(e) => {
//                   e.preventDefault();
//                   setFormData(initialState);
//                 }}
//               >
//                 מחיקה
//               </button>
//             </div>
//           </div>
//         </Form>
//       </Wrapper>
//       <MessagesContainer messages={Array.isArray(messages) ? messages : []} />
//     </>
//   );
// };

// export default AddMessage;


import { useState, useEffect } from "react";
import {
  BirthdayMessageDetails,
  GeneralMessageDetails,
} from "../components/messages";
import { MessagesContainer } from "../components/messages";
import { FormRowSelect } from "../components";
import Wrapper from "../assets/wrappers/DashboardFormPage";
import { useOutletContext, redirect, useParams } from "react-router-dom";
import { Form, useNavigation, useLoaderData } from "react-router-dom";
import { toast } from "react-toastify";
import { customFetch } from "../utils/custom-fetch.js";

export const loader = async ({ params }) => {
  try {
    const buildingResponse = await customFetch.get(`/buildings/${params.id}`);
    const messagesResponse = await customFetch(
      `/messages?buildingId=${params.id}`
    );

    let messageToEdit = null;
    if (params.messageId) {
      const messageResponse = await customFetch.get(
        `/messages/${params.messageId}`
      );
      messageToEdit = messageResponse.data;
    }

    window.scrollTo(0, 0);

    return {
      building: buildingResponse.data,
      messages: messagesResponse.data,
      messageToEdit,
    };
  } catch (error) {
    toast.error(error.response?.data?.msg);
    return redirect("/dashboard/all-buildings");
  }
};

export const action = async ({ request, params }) => {
  const formData = await extractFormData(request);
  const fullData = constructMessageDetails(formData, params.id);
  try {
    const endpoint = params.messageId ? `/messages/${params.messageId}` : "/messages";
    const method = params.messageId ? 'put' : 'post';
    await customFetch[method](endpoint, fullData);
    toast.success(`ההודעה ${params.messageId ? 'עודכנה' : 'נוצרה'} בהצלחה`);
    return redirect("/dashboard/all-messages");
  } catch (error) {
    toast.error(error?.response?.data?.msg || "שגיאה בשמירת ההודעה");
    return error;
  }
};

async function extractFormData(request) {
  const formData = await request.formData();
  const data = Object.fromEntries(formData);
  return data;
}

function constructMessageDetails(data, buildingId) {
  let messageDetails = {};
  switch (data.messageType) {
    case "יום הולדת":
      messageDetails = {
        celebratorName: data["birthdayDetails.celebratorName"],
        greeting: data["birthdayDetails.greeting"],
        birthdayDate: data["birthdayDetails.birthdayDate"],
      };
      break;
    case "כללית":
      messageDetails = {
        messageOption: data["generalMessageDetails.messageOption"],
        startingDate: data["generalMessageDetails.startingDate"] || "",
        expirationDate: data["generalMessageDetails.expirationDate"] || "",
        text: data["generalMessageDetails.text"] || "",
      };
      break;
    default:
      throw new Error("Unhandled message type");
  }

  return {
    messageType: data.messageType,
    messageDetails,
    target: {
      type: "building",
      buildings: [buildingId], // Use the passed buildingId directly
    },
  };
}

const AddMessage = () => {
  const { id, messageId } = useParams();

  if (!id) {
    navigate("/dashboard/all-messages");
  }

  const { building, messages, messageToEdit } = useLoaderData();
  
  const { user } = useOutletContext();
  const navigate = useNavigation();
  const isSubmitting = navigate.state === "submitting";

  // הגדרת המצב הראשוני
  const getInitialState = () => {
    if (messageToEdit) {
      return {
        author: messageToEdit.author,
        messageType: messageToEdit.messageType,
        buildingId: messageToEdit.target?.buildings?.[0] || id, // תיקון - לקחת מה-target
        generalMessageDetails: messageToEdit.messageType === "כללית" 
          ? messageToEdit.messageDetails 
          : {
              messageOption: "קבועה",
              startingDate: "",
              expirationDate: "",
              text: "",
            },
        birthdayDetails: messageToEdit.messageType === "יום הולדת" 
          ? messageToEdit.messageDetails 
          : {
              celebratorName: "",
              greeting: "",
              age: "",
              birthdayDate: "",
            },
      };
    } else {
      return {
        author: user._id,
        messageType: "כללית",
        buildingId: id,
        generalMessageDetails: {
          messageOption: "קבועה",
          startingDate: "",
          expirationDate: "",
          text: "",
        },
        birthdayDetails: {
          celebratorName: "",
          greeting: "",
          age: "",
          birthdayDate: "",
        },
      };
    }
  };

  const [formData, setFormData] = useState(getInitialState());

  useEffect(() => {
    if (messageToEdit) {
      setFormData(getInitialState());
    }
  }, [messageToEdit]);

  const handleMessageTypeChange = (e) => {
    const { value } = e.target;

    // תיקון - שמירה על הנתונים הקיימים במקום איפוס מלא
    setFormData(prevData => ({
      ...prevData,
      messageType: value,
      // לא לאפס את generalMessageDetails ו birthdayDetails
      // כדי לשמור על הנתונים שהמשתמש כבר הזין
    }));
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    const keys = name.split(".");

    if (keys.length > 1) {
      // Handle nested objects
      setFormData((prevFormData) => ({
        ...prevFormData,
        [keys[0]]: {
          ...prevFormData[keys[0]],
          [keys[1]]: value,
        },
      }));
    } else {
      // Handle non-nested properties
      setFormData((prevFormData) => ({
        ...prevFormData,
        [name]: value,
      }));
    }
  };

  const validateForm = (formData) => {
    const { messageType, generalMessageDetails, birthdayDetails } = formData;

    // Check if required fields for the selected message type are filled
    if (messageType === "יום הולדת") {
      const { celebratorName, greeting, birthdayDate } = birthdayDetails;

      return Object.values({
        celebratorName,
        greeting,
        birthdayDate,
      }).every((field) => field !== "");
    } else if (messageType === "כללית") {
      const { text, messageOption, startingDate, expirationDate } = generalMessageDetails;
      
      if (!text || text.trim() === "") {
        return false;
      }
      
      if (messageOption === "קבועה") {
        return true;
      } else if (messageOption === "עד תאריך") {
        return expirationDate !== "";
      } else if (messageOption === "מתאריך") {
        return startingDate !== "";
      } else if (messageOption === "בין תאריכים") {
        return startingDate !== "" && 
               expirationDate !== "" && 
               startingDate < expirationDate;
      }
      
      return false;
    } else {
      console.warn("Unhandled message type:", messageType);
      return false;
    }
  };

  return (
    <>
      <Wrapper className="full-page">
        <Form method="post" className="form">
          <h4 className="form-title">
            {messageToEdit ? "עריכת הודעה" : "הוספת הודעה"}{" "}
            {building.building.city}, {building.building.street}{" "}
            {building.building.houseNumber}
          </h4>
          <div className="form-center">
            <FormRowSelect
              labelText="סוג ההודעה"
              type="text"
              name="messageType"
              list={["כללית", "יום הולדת"]}
              handleChange={handleMessageTypeChange}
              value={formData.messageType}
              isRequired={true}
            />

            {formData.messageType === "יום הולדת" && (
              <BirthdayMessageDetails
                formData={formData.birthdayDetails}
                handleInputChange={handleInputChange}
              />
            )}

            {formData.messageType === "כללית" && (
              <GeneralMessageDetails
                formData={formData.generalMessageDetails} // תיקון - העברת הנתונים הנכונים
                handleInputChange={handleInputChange}
              />
            )}

            <div className="btn-container">
              <button
                type="submit"
                className="btn btn-block form-btn"
                disabled={isSubmitting || !validateForm(formData)}
              >
                {isSubmitting ? "שומר..." : messageToEdit ? "עדכן" : "שמירה"}
              </button>
              <button
                className="btn btn-block clear-btn"
                onClick={(e) => {
                  e.preventDefault();
                  setFormData(getInitialState());
                }}
              >
                מחיקה
              </button>
            </div>
          </div>
        </Form>
      </Wrapper>
      <MessagesContainer messages={Array.isArray(messages) ? messages : []} />
    </>
  );
};

export default AddMessage;